import { getAnalytics, isSupported, logEvent, setUserProperties } from "firebase/analytics";
import { firebase } from "@core/firebase/app";

/**
 * Google Analytics Service
 * Provides simple tracking functions for page views and user properties
 */

let analyticsPromise: Promise<ReturnType<typeof getAnalytics> | null> = isSupported()
  .then((ok) => ok ? getAnalytics(firebase.app) : null)
  .catch(() => null);

/**
 * Track an event to Google Analytics
 * @param event - Event name
 * @param params - Event parameters
 */
export async function track(event: string, params?: Record<string, any>) {
  const analytics = await analyticsPromise;
  if (analytics) {
    logEvent(analytics, event, params);
  }
}

/**
 * Set user properties in Google Analytics
 * @param props - User properties to set
 */
export async function setProps(props: Record<string, any>) {
  const analytics = await analyticsPromise;
  if (analytics) {
    setUserProperties(analytics, props);
  }
}
